import { chipsMapping } from "../../config/chip/chipConfig.js";
import { useMessageFormatter } from "../../intl/hooks.js";
import "../../intl/shared-resources/serverResponse.js";
const useChipValue = (value, chipName, label) => {
  const formatMessage = useMessageFormatter();
  const chip = chipsMapping[chipName][value];
  const chipLabel = chip?.label ? chip.labelTypeString ? chip.label : formatMessage(chip.label) : label ? formatMessage(label) : value;
  return { chip, chipLabel };
};
export {
  useChipValue
};
//# sourceMappingURL=ChipValue.hooks.js.map
